export default {"src":"/_next/static/media/ezETH.813916d3.svg","height":199,"width":200};